<header id="header" class="header" *ngIf="showPortalUI">
  <nav class="navbar fixed-top navbar-expand-lg scrolling-navbar navbgColor">
    <img class="logo navbar-brand" href="" src="./assets/Images/Header/Accenture1.png">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto no-margin">
        <li class="nav-item  waves-light headerDesc" mdbWavesEffect>
          <span>
            <a class="nav-linkCompany  text-uppercase text-white" href="#">
              <strong>{{CompanyTitle}}</strong>
              <span class="sr-only">(current)</span></a>
          </span>

        </li>
      </ul>
      <ul class="navbar-nav ml-auto nav-flex-icons">


        <li class="nav-item">
          <a class="nav-link mt-2" text-white href="#">
            Hi, <strong>{{UserName}}</strong></a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink-333" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <mdb-icon fas icon="user" style="font-size:xx-large;"></mdb-icon>
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-default  align-items-center" aria-labelledby="navbarDropdownMenuLink-333">      
            
          <a class="d-flex align-items-center" *ngIf="showAdmin">            
              <a class="alink active" data-toggle="modal" data-target="#modalAdmin" (click)="LoadAdmin();" >
              <h6><span>Admin</span> </h6>
            </a>
          </a>

          <a class="d-flex align-items-center" *ngIf="UserDownloadAccess">            
           
            <a  class="alink active" data-toggle="modal" data-target="#modalSpoolDownload" (click)="spoolDownload();" >
            <h6><span>Spool Download</span> </h6>
            </a>
          
          </a>

          <a class="d-flex align-items-center" *ngIf="showDocketUpload" >            
           
           <a  class="alink active" data-toggle="modal" data-target="#docketUpload" (click)="LoadDocketUpload();" >
           <h6><span>Docket Upload</span> </h6>
           </a>

         
         </a>

         <!-- <a class="d-flex align-items-center">            
           
          <a  class="alink active" data-toggle="modal"  data-target="#projectPermission" (click)="LoadProjectPermission();" >
          <h6><span>Project Permission</span> </h6>
          </a>
          
        
        </a> -->


          

          

            
            <a class=" d-flex align-items-center">
              <i class="fas fa-sign-out-alt iconColor margin"></i>
              <a class="alink active"
              (click)="logOut()">
              <h6><span>LogOut</span> </h6>
            </a>
            </a> 
          </div>
        </li>

      </ul>
    </div>
  </nav>
</header>